export const ANALYTICS_EVENTS = {
  pageViewed: 'page.viewed',
  userLoginSuccess: 'user.login.success',
  userLoginFailure: 'user.login.failure',
  userLoginCodeResent: 'user.login.code_resent',
  userLogout: 'user.logout',
  clientError: 'client.error',

  // New experience actions
  newExperienceBannerDismissed: 'new_experience.banner.dismissed',
  newExperienceInviteDismissed: 'new_experience.invite.dismissed',
  newExperienceEnabled: 'new_experience.enabled',
  newExperienceDisabled: 'new_experience.disabled',

  // Mobile web warning actions
  mobileWebWarningShown: 'mobile_web_warning.shown',
  mobileWebWarningAcknowledged: 'mobile_web_warning.acknowledged',

  // Scan actions
  scanCreated: 'scan.created',
  scanUpdated: 'scan.updated',
  scanArchived: 'scan.archived',
  scanUnarchived: 'scan.unarchived',
  scanSubmittedForReview: 'scan.submitted_for_review',
  scanRevertedToDispatched: 'scan.reverted_to_dispatched',
  scanApproved: 'scan.approved',
  scanChangesRequested: 'scan.changes_requested',
  scanChangeOrderCanceled: 'scan.change_order_canceled',
  scanDispatched: 'scan.dispatched',
  scanExportedExcel: 'scan.exported.excel',
  scanExportedPdf: 'scan.exported.pdf',
  scanExportedPhotosZip: 'scan.exported.photos.zip',
  scanGroupCloned: 'scan.group.cloned',
  scanGroupDeleted: 'scan.group.deleted',
  scanTaskAdded: 'scan.task.added',
  scanTaskDeleted: 'scan.task.deleted',
  scanPhotosUploaded: 'scan.photos.uploaded',
  scanPhotosMoved: 'scan.photos.moved',
  scanPhotosCopied: 'scan.photos.copied',
  scanPhotoAssignmentsRemoved: 'scan.photo_assignments.removed',
  scanNoteAdded: 'scan.note.added',
  scanTaskProgressUpdated: 'scan.task.progress.updated',

  // AI walkthrough actions
  aiWalkthroughSubmitted: 'ai_walkthrough.submitted',
  aiWalkthroughCompleted: 'ai_walkthrough.completed',
  aiWalkthroughFailed: 'ai_walkthrough.failed',

  // Property actions
  propertyCreated: 'property.created',
  propertyArchived: 'property.archived',
  propertyUnarchived: 'property.unarchived',

  // Project actions
  projectCreated: 'project.created',
  projectUpdated: 'project.updated',
  projectArchived: 'project.archived',
  projectUnarchived: 'project.unarchived',

  // Contractor actions
  contractorCreated: 'contractor.created',
  contractorUpdated: 'contractor.updated',
  contractorArchived: 'contractor.archived',
  contractorUnarchived: 'contractor.unarchived',

  // Market actions
  marketCreated: 'market.created',
  marketUpdated: 'market.updated',
  marketArchived: 'market.archived',
  marketUnarchived: 'market.unarchived',

  // User actions
  userAdded: 'user.added',
  userUpdated: 'user.updated',
  userRemoved: 'user.removed',

  // Product actions
  productCreated: 'product.created',
  productUpdated: 'product.updated',
  productArchived: 'product.archived',
  productUnarchived: 'product.unarchived',

  // Scan Template actions
  scanTemplateCreated: 'scan_template.created',
  scanTemplateUpdated: 'scan_template.updated',
  scanTemplateArchived: 'scan_template.archived',
  scanTemplateUnarchived: 'scan_template.unarchived',

  // Audience document actions
  audienceDocCreated: 'audience_doc.created',
  audienceDocSettingsUpdated: 'audience_doc.settings.updated',
  audienceDocShareLinkCreated: 'audience_doc.share_link.created',
  audienceDocShareLinkReplaced: 'audience_doc.share_link.replaced',
  audienceDocShareLinkRevoked: 'audience_doc.share_link.revoked',
} as const;

export const NEW_EXPERIENCE_ANALYTICS = {
  modes: {
    new: 'new',
    original: 'original',
  },
  changeSources: {
    accountToggle: 'account_toggle',
    projectBanner: 'project_banner',
  },
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];
